import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StatusSplitEnum } from '@wlp/ui-px-split';
import { LoadingService } from '../../../../../../../../core/layout/services/loading.service';
import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';
import { ModalController, NavController } from '@ionic/angular';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { ModalAlertComponent } from '../../../../../modals/modal-alert/modal-alert.component';
import { SplitService } from '@wlp/ui-bs-split';
import { SplitDto, SplitItemDto, TypeCodeEnum } from '@wlp/ui-px-split';
import { ActivatedRoute } from '@angular/router';
import { MaskService } from '@wlp/ui-bs-util';

@Component({
  selector: 'split-details',
  templateUrl: './split-details.page.html',
  styleUrls: ['./split-details.page.scss'],
})

export class SplitDetailsPage implements OnInit {
  @ViewChild(`btnListDate`, { static: false }) public btnListDate: ElementRef;
  public uuidSplit: string;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  userProfile: UserInfoProfile;

  public splitDetailData: SplitItemDto[];
  public splitFull: SplitDto;
  public typeCode: TypeCodeEnum = TypeCodeEnum.BOALI;
  public retainedValue: number;
  public liquidValue: number;

  constructor(
    public loadingService: LoadingService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    protected userInfoService: UserInfoService,
    public modalController: ModalController,
    private navCtrl: NavController,
    public splitService: SplitService,
    private route: ActivatedRoute,
    private maskService: MaskService
  ) { }

  public ngOnInit() {
    this.initializeLayoutConfig();

    this.route.queryParams.subscribe(params => {
      this.uuidSplit = params['uuidSplit'];
    });

    this.loadUser();
  }

  private initializeLayoutConfig() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
  }

  private async loadUser() {
    try {
      this.userProfile = await this.userInfoService.getInfoProfile();
      this.findSplitByUuid(this.uuidSplit, this.userProfile.uuidAccount, this.typeCode);
      this.fetchSplitFinancialSummary();
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  public findSplitByUuid(uuid: string, uuidAccountPayment: string, typeCode: TypeCodeEnum) {
    this.loadingService.show();
    this.splitService.findSplitByUuid(uuid, uuidAccountPayment, typeCode).subscribe({
      next: async (split: SplitDto) => {
        this.splitFull = split;
        this.splitDetailData = split.items;
        this.loadingService.hide();
      },
      error: () => {
        this.loadingService.hide();
        this.showErrorModal('Não foi possível consultar detalhes do split')
      }
    });
  }

  public async fetchSplitFinancialSummary() {
    const statusValues = await this.splitService.resumeSplitDataByTypeCode(
      this.uuidSplit,
      this.userProfile.uuidAccount,
      null,
      null,
      null,
      null,
      this.typeCode
    ).toPromise();

    this.retainedValue = statusValues.splitDiscountedTotal;
    this.liquidValue = statusValues.liquid;
  }

  public applyStatusColor(status: StatusSplitEnum) {
    switch (status) {
      case StatusSplitEnum.CREATED:
      case StatusSplitEnum.IN_PROCESS:
        return 'status blue';
      case StatusSplitEnum.PROCESS_COMPLETED:
        return 'status green';
      default:
        return 'status gray';
    }
  }

  public applyStatusText(status: StatusSplitEnum) {
    switch (status) {
      case StatusSplitEnum.CREATED:
        return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.CREATED';
      case StatusSplitEnum.IN_PROCESS:
        return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.IN_PROCESS';
      case StatusSplitEnum.PROCESS_COMPLETED:
        return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.PROCESS_COMPLETED';
      default:
        return status;
    }
  }

  goToSplitManagmentPage() {
    this.navCtrl.navigateBack('split/franchisor')
  }

  public async showErrorModal(message: string) {
    const modalRef = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: 'warning-circle',
        message,
        confirmBtn: 'FECHAR',
        translate: true,
      },
      backdropDismiss: false,
    });
    await modalRef.present();
  }

  public formatCnpjCpf(document: string) {
    return this.maskService.formatCnpjCpf(document);
  }
}
